<template>
    <div class="form-inline">
        <b-input-group class="mb-2 form-inline" :prepend="showVanOp">
            <b-input-group-prepend is-text>
                <b-form-checkbox
                    class="mr-n2"
                    v-model="status"
                    name="checkbox-dag"
                    value="day"
                    unchecked-value="period"
                    @input="emitValues"
                >
                    <span class="sr-only">{{
                        $t('com_dag', { ns: 'common' })
                    }}</span>
                </b-form-checkbox>
            </b-input-group-prepend>
            <b-input-group v-if="!useTimeInput">
                <b-form-datepicker
                    key="aangeraakt"
                    v-model="van"
                    :date-format-options="{
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit'
                    }"
                    @input="emitValues"
                ></b-form-datepicker>
            </b-input-group>
            <b-input-group v-if="useTimeInput">
                <b-form-input
                    v-model="localDateVan"
                    :type="'date'"
                    @change="setVanTimed"
                ></b-form-input>
            </b-input-group>
        </b-input-group>
        <b-input-group
            v-if="!isDagSelectie"
            class="mb-2 form-inline"
            :prepend="$t('com_tot', { ns: 'common' })"
            :label="$t('com_tot', { ns: 'common' })"
        >
            <b-input-group v-if="!useTimeInput">
                <b-form-datepicker
                    v-model="tot"
                    :date-format-options="{
                        year: 'numeric',
                        month: 'short',
                        day: '2-digit'
                    }"
                    @input="emitValues"
                ></b-form-datepicker>
            </b-input-group>
            <b-input-group v-if="useTimeInput">
                <b-form-input
                    v-model="localDateTot"
                    :type="'date'"
                    @change="setTotTimed"
                ></b-form-input>
            </b-input-group>
        </b-input-group>
        <b-input-group
            v-else-if="showBakgroepOption"
            class="mb-2 form-inline"
            :label="strBakgroepPartij"
        >
            <b-form-input
                :placeholder="strBakgroepPartij"
                v-model="bgnummer"
            ></b-form-input>
            <b-input-group-append>
                <b-button @click="getDateForBatchGroup()" class="bgc_aux_normal"
                    >Ok</b-button
                >
            </b-input-group-append>
        </b-input-group>
    </div>
</template>
<script>
import DateHelper from '../../models/DateHelper';
import { loadItem } from '../../models/DataHelper';
import { Feature } from '../../models/Features';
export default {
    name: 'PeriodSelector',
    data: function () {
        return {
            errorMessage: '',
            status: 'day',
            showDag: true,
            van: null,
            tot: null,
            aangeraakt: 1,
            localDateVan: null, //mogelijk niet nodig
            localDateTot: null, //mogelijk niet nodig
            bgnummer: null,
            startDateObject: {
                van: null,
                tot: null,
                dag: 'day'
            }
        };
    },
    model: {
        prop: 'selected',
        event: 'input'
    },
    props: {
        periodDays: {
            type: Number,
            default: 1
        },
        selected: {
            type: Object
        },
        showBakgroepOption: {
            type: Boolean,
            default: false
        },
        slackTillDate: {
            type: Number,
            default: 0
        },
        timeInput: {
            type: Boolean,
            default: false
        },
        forceToday: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        useTimeInput() {
            if (this.timeInput) {
                return false;
            }
            return !this.checkFeature('conf_UseDateTimePicker');
        },
        isVersion10() {
            return (
                this.$store.getters['masterdata/getPackageVersion'] ==
                window.constants.VERSION10
            );
        },
        strBakgroepPartij() {
            return this.isVersion10
                ? this.$t('com_batchnumber', { ns: 'common' })
                : this.$t('prod_bakgroep', { ns: 'production' });
        },
        groupingPeriods() {
            return [
                { value: 'day', text: this.$t('com_dag', { ns: 'common' }) },
                { value: 'week', text: this.$t('com_week', { ns: 'common' }) },
                {
                    value: 'month',
                    text: this.$t('com_maand', { ns: 'common' })
                },
                { value: 'year', text: this.$t('com_jaar', { ns: 'common' }) }
            ];
        },
        isDagSelectie() {
            return this.status == 'day';
        },
        showVanOp() {
            return this.isDagSelectie
                ? this.$t('com_optijdstip', { ns: 'common' })
                : this.$t('com_van', { ns: 'common' });
        }
    },
    methods: {
        checkFeature(feature) {
            const key = Feature.enum(feature);
            return this.$root.handleFeature(key);
        },
        set_input() {
            sessionStorage.setItem('van', this.van);
            sessionStorage.setItem('tot', this.tot);
            sessionStorage.setItem(
                'dag',
                this.isDagSelectie ? 'day' : 'period'
            );
            this.$emit('change', this.startDateObject);
        },
        emitValues() {
            //this.van = this.isDagSelectie ? this.tot : this.van;
            this.aangeraakt += 1;
            this.startDateObject.dag = this.isDagSelectie ? 'day' : 'period';
            this.startDateObject.van = this.van;
            this.startDateObject.tot = this.tot;
            if (!this.isDagSelectie && this.tot < this.van) {
                this.startDateObject.tot = this.van;
                this.tot = this.van;
                this.localDateTot = DateHelper.DateForInput(
                    this.startDateObject.tot,
                    true,
                    false
                );
            }
            this.bgnummer = null;
            this.set_input();
        },
        setVanTimed() {
            // set timer voor 500 msec en reset die iedere keer als wijzigging wordt doorgevoerd
            // als timer afloopt dan van zetten, dit voorkomt dat er bij het invoeren van een datum steeds een wijziging wordt doorgevoerd
            if (this.interval) {
                clearTimeout(this.interval);
            }
            this.interval = setTimeout(() => {
                if (this.localDateVan) {
                    this.van = this.localDateVan; // DateHelper.DateFromInput(this.localDateVan, null);
                    this.emitValues();
                }
            }, 750);
        },
        setTotTimed() {
            if (this.interval) {
                clearTimeout(this.interval);
            }
            this.interval = setTimeout(() => {
                if (this.localDateTot) {
                    this.tot = this.localDateTot; // DateHelper.DateFromInput(this.localDateTot, null);
                    this.emitValues();
                }
            }, 750);
        },
        setInputs() {
            this.localDateVan = DateHelper.DateForInput(
                this.startDateObject.van,
                true,
                false
            );
            this.localDateTot = DateHelper.DateForInput(
                this.startDateObject.tot,
                true,
                false
            );
        },
        addDays(date, days) {
            const result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        },
        async getDateForBatchGroup() {
            if (this.bgnummer.trim() != undefined) {
                const date = await loadItem(
                    'components/loadBatchGroupProductionDate',
                    { productionnumber: this.bgnummer.trim() },
                    this.$t
                );
                if (date != undefined && date != '') {
                    this.van = DateHelper.MakeDateTime(date).toJSDate();
                    this.startDateObject.van = this.van;
                    this.startDateObject.tot = this.van;
                    this.set_input();
                } else {
                    const bericht =
                        this.$t('com_nodata', { ns: 'common' }) +
                        '? ' +
                        this.$t('com_xnotfound', {
                            ns: 'common',
                            val: this.$t('prod_bakgroep', { ns: 'production' })
                        }) +
                        ': ' +
                        this.bgnummer.trim();
                    this.$root.showMessageBox(bericht);
                }
            }
        }
    },
    mounted() {
        const opgeslagenvan = sessionStorage.getItem('van');
        const opgeslagentot = sessionStorage.getItem('tot');
        const opgeslagendag = sessionStorage.getItem('dag');
        const dagen = this.periodDays == 1 ? 0 : this.periodDays;
        const startdag = this.forceToday ? new Date() : opgeslagenvan;
        const datums = DateHelper.determineVanTot(startdag, dagen);
        this.showDag = opgeslagenvan
            ? opgeslagendag == 'day'
            : this.periodDays == 1;
        this.status = this.showDag == true ? 'day' : 'period';
        this.van = opgeslagenvan ? opgeslagenvan : datums.van;
        this.tot = opgeslagentot ? opgeslagentot : datums.tot;
        if (this.forceToday) {
            this.van = datums.van;
            this.tot = datums.tot;
        }
        if (this.showDag == true) {
            this.tot = this.van; //this.addDays(this.van, this.slackTillDate);
        }
        this.startDateObject.van = this.van;
        this.startDateObject.tot = this.tot;
        this.setInputs();
        this.set_input();
    },
    created() {}
};
</script>

<style scoped></style>
